export function toArray<T>(val: T | T[]): T[] {
  if (val === undefined || val === null) {
    return [];
  }

  if (Array.isArray(val)) {
    return val;
  }

  return [val];
}
